import styled, { css } from 'styled-components';

const errorStyles = css`
  border-color: #ff4f4f;

  &:hover {
    border-color: #ff4f4f;
  }

  &:focus {
    border-color: #ff4f4f;
  }
`;

const getPlaceholderColor = ({ placeholderError, isLightMode }) => {
  if (placeholderError) {
    return '#ff4f4f';
  }

  if (isLightMode) {
    return '#6e6e6e';
  }

  return '#999999';
};

export default styled.input`
  width: 100%;
  height: 49px;
  padding: 15px 25px;
  border-radius: 15px;
  border: 1px solid ${props => (props.isLightMode ? '#d3d3d3' : '#333333')};
  background-color: ${props => (props.isLightMode ? '#f3f5f4' : '#3a3b3c')};
  color: ${props => (props.isLightMode ? '#000000' : '#ffffff')};
  font-family: var(--google-sora-cdn);
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: ${props => getPlaceholderColor(props)};
  }

  &:focus {
    border-color: #0078ff;
  }

  &:hover {
    border-color: ${props => (props.isLightMode ? '#bdbdbd' : '#404040')};
  }

  ${props => props.hasError && errorStyles};
`;
